import { useCallback } from "react";
import { ApiState } from "../api/useApiState";

export function useRefreshAll(...apiStates: ApiState<unknown>[]){
    const refreshes = apiStates.map(a => a.refresh);
    return useCallback(async () => {
        await Promise.all(refreshes.map(r => r()));
    }, refreshes);
}